// Lytics segment experiment
// See https://industrydive.atlassian.net/browse/ENGB-934 for details
// Lookup table for segments https://docs.google.com/spreadsheets/d/1vkHj3GwIU97QNExusEldsdNQEjkyPYWvSfsnC8MaAm4/edit#gid=0

const lookup = {
  any_agriculture_dive_subs: 'aa',
  any_automotive_dive_subs: 'ab',
  any_banking_dive_subs: 'ac',
  any_biopharma_dive_subs: 'ad',
  any_cstore_dive_subs: 'ae',
  any_cfo_dive_subs: 'af',
  cfo_dive_tech_valid_subs: 'ag',
  any_cfo_balance_subs: 'ah',
  any_cio_dive_subs: 'ai',
  any_construction_dive_subs: 'aj',
  any_cybersecurity_dive_subs: 'ak',
  any_higher_ed_dive_subs: 'al',
  any_k12_dive_subs: 'am',
  any_facilities_dive_subs: 'an',
  any_fashion_dive_subs: 'ao',
  any_food_dive_subs: 'ap',
  any_grocery_dive_subs: 'aq',
  any_healthcare_dive_subs: 'ar',
  any_hotel_dive_subs: 'as',
  any_hr_dive_subs: 'at',
  any_legal_dive_subs: 'au',
  any_manufacturing_dive_subs: 'av',
  any_marketing_dive_subs: 'aw',
  any_medtech_dive_subs: 'ax',
  any_mobile_marketer_subs: 'ay',
  any_multifamily_dive_subs: 'az',
  any_packaging_dive_subs: 'a0',
  any_payments_dive_subs: 'a1',
  any_pharmavoice_subs: 'a2',
  any_restaurant_dive_subs: 'a3',
  any_retail_dive_subs: 'a4',
  any_smart_cities_dive_subs: 'a5',
  any_social_media_today_subs: 'a6',
  any_supplychain_dive_subs: 'a7',
  any_transport_dive_subs: 'a8',
  any_utility_dive_subs: 'a9',
  any_waste_dive_subs: 'ba',
  lt_15_million_company_revenue: 'bb',
  lt_20_million_company_revenue: 'bc',
  gt_100m_company_revenue: 'bd',
  gt_500m_company_revenue: 'be',
  '250k_to_at_least_5m_company_revenue': 'bf',
  '5m_to_20m_company_revenue': 'bg',
  '20m_5000m_company_revenue': 'bh',
  all_cfos: 'bi',
  retail_holiday_edition_valid_subscribers: 'bj',
  banking_dive_valid_subscribers: 'bk',
  biopharma_dive_valid_subscribers: 'bl',
  cfo_dive_valid_subscribers: 'bm',
  cio_dive_valid_subscribers: 'bn',
  construction_dive_valid_subscribers: 'bo',
  education_dive_higher_ed_valid_subscribers: 'bp',
  education_dive_k12_valid_subscribers: 'bq',
  food_dive_valid_subscribers: 'br',
  grocery_dive_valid_subscribers: 'bs',
  healthcare_dive_valid_subscribers: 'bt',
  hr_dive_valid_subscribers: 'bu',
  hr_dive_talent_valid_subscribers: 'bv',
  marketing_dive_valid_subscribers: 'bw',
  medtech_dive_valid_subscribers: 'bx',
  mobile_marketer_valid_subscribers: 'by',
  restaurant_dive_valid_subscribers: 'bz',
  retail_dive_valid_subscribers: 'b0',
  retail_dive_dtc_valid_subscribers: 'b1',
  smart_cities_dive_valid_subscribers: 'b2',
  social_media_today_valid_subscribers: 'b3',
  supply_chain_dive_valid_subscribers: 'b4',
  transport_dive_valid_subscribers: 'b5',
  utility_dive_valid_subscribers: 'b6',
  waste_dive_valid_subscribers: 'b7',
  all_target_readers: 'b8',
  automotive_dive_high_quality_target_readers: 'b9',
  banking_dive_high_quality_target_readers: 'ca',
  biopharma_dive_target_readers: 'cb',
  cstore_dive_high_quality_target_readers: 'cc',
  cfo_dive_high_quality_target_readers_: 'cd',
  cio_dive_high_quality_target_readers: 'ce',
  construction_dive_high_quality_target_readers: 'cf',
  cybersecurity_dive_high_quality_target_readers: 'cg',
  facilities_dive_high_quality_target_readers: 'ch',
  fashion_dive_high_quality_target_readers: 'ci',
  food_dive_high_quality_target_readers: 'cj',
  grocery_dive_high_quality_target_readers: 'ck',
  healthcare_dive_target_readers: 'cl',
  higher_ed_high_quality_target_readers: 'cm',
  hotel_dive_high_quality_target_readers: 'cn',
  hr_dive_high_quality_target_readers: 'co',
  hr_dive_learning_high_quality_target_readers: 'cp',
  hr_dive_talent_high_quality_target_readers: 'cq',
  k12_high_quality_target_readers: 'cr',
  legal_dive_high_quality_target_readers: 'cs',
  manufacturing_dive_high_quality_target_readers: 'ct',
  marekting_dive_high_quality_target_readers: 'cu',
  medtech_high_quality_target_readers: 'cv',
  mobile_marketer_high_quality_target_readers: 'cw',
  multifamily_dive_high_quality_target_readers: 'cx',
  packaging_dive_high_quality_target_readers: 'cy',
  payments_dive_high_quality_target_readers: 'cz',
  pharmavoice_high_quality_target_readers: 'c0',
  restaurant_dive_high_quality_target_readers: 'c1',
  retail_dive_high_quality_target_readers: 'c2',
  smart_cities_dive_high_quality_target_readers: 'c3',
  socialmediatoday_target_readers: 'c4',
  supply_chain_dive_high_quality_target_readers: 'c5',
  transport_dive_high_quality_target_readers: 'c6',
  utility_dive_high_quality_target_readers: 'c7',
  waste_dive_high_quality_target_readers: 'c8',
  banking_dive_fintech_valid_subscribers: 'c9',
  biopharma_dive_emerging_biotech_valid_subscribers: 'da',
  biopharma_dive_manufacturing_valid_subscribers: 'db',
  biopharma_dive_marketing_valid_subscribers: 'dc',
  construction_dive_tech_valid_subscribers: 'dd',
  education_dive_k12_curriculum_valid_subscribers: 'de',
  food_dive_ingredients_valid_subscribers: 'df',
  healthcare_dive_it_valid_subscribers: 'dg',
  healthcare_dive_payer_valid_subscribers: 'dh',
  hr_dive_compensation_benefits_valid_subscribers: 'di',
  hr_dive_compliance_valid_subscribers: 'dj',
  hr_dive_diversity_inclusion_valid_subscribers: 'dk',
  hr_dive_learning_valid_subscribers: 'dl',
  hr_dive_recruiting_valid_subscribers: 'dm',
  marketing_dive_agencies_valid_subscribers: 'dn',
  marketing_dive_mobile_valid_subscribers: 'do',
  retail_dive_marketing_valid_subscribers: 'dp',
  retail_dive_mobile_commerce_valid_subscribers: 'dq',
  retail_dive_operations_valid_subscribers: 'dr',
  retail_dive_tech_valid_subscribers: 'ds',
  supply_chain_dive_operations_valid_subscribers: 'dt',
  supply_chain_dive_procurement_valid_subscribers: 'du',
  utility_dive_demand_response_valid_subscribers: 'dv',
  utility_dive_solar_valid_subscribers: 'dw',
  utility_dive_storage_valid_subscribers: 'dx',
  waste_dive_recycling_valid_subscribers: 'dy',
  all_cio_job_level: 'dz',
  all_cso_ciso_job_level: 'd0',
  all_cto_job_level: 'd1',
  all_users_on_a_primary_list_in_sailthru: 'd2',
  any_administration_job_function: 'd3',
  any_analyst_job_level: 'd4',
  any_associate_job_level: 'd5',
  any_bank_finance_company_type: 'd6',
  any_biz_dev_sales_job_function: 'd7',
  any_clevel_job_level: 'd8',
  any_construction_company_type: 'd9',
  any_customer_relations_job_function: 'ea',
  any_cx_job_function: 'eb',
  any_director_vp_job_level: 'ec',
  any_education_company_type: 'ed',
  any_finance_job_function: 'ee',
  any_food_and_bev_company_type: 'ef',
  any_food_service_company_type: 'eg',
  any_hr_job_function: 'eh',
  any_manager_job_level: 'ei',
  any_manufacturing_company_type: 'ej',
  any_marketing_job_function: 'ek',
  any_media_company_type: 'el',
  any_operations_analysis_job_function: 'em',
  any_operations_job_function: 'en',
  any_product_job_function: 'eo',
  any_retail_company_type: 'ep',
  any_supply_chain_job_function: 'eq',
  any_tech_company_type: 'er',
  any_telecom_company_type: 'es',
  any_transportation_company_type: 'et',
  any_transportation_job_function: 'eu',
  any_utility_company_type: 'ev',
  any_ux_job_function: 'ew',
  any_waste_recycling_company_type: 'ex',
  company_size_1_249: 'ey',
  company_size_1000_4999: 'ez',
  company_size_1000_plus: 'e0',
  company_size_250_499: 'e1',
  company_size_5000_9999: 'e2',
  seh_k12_at_risk_users_in_2023_churn_campaign: 'e3',
  seh_k12_at_risk_users_who_clicked_2023_churn_campagin: 'e4',
  square_food_bev_audience: 'e5',
  square_restaurant_audience: 'e6',
  square_retail_audience: 'e7',
  any_cx_dive_subs: 'e8',
  any_esg_dive_subs: 'e9',
  cfo_balance_high_quality_target_readers: 'fa',
  cx_dive_high_quality_target_readers: 'fb',
  esg_dive_high_quality_target_readers: 'fc',
  informauploadsnov2022: 'fd',
  ladders_uploads_2021: 'fe',
  ladders_utm_campaign_tracking: 'ff',
  agriculture_dive_high_quality_target_readers: 'fg',
  all_marketing_related_audience: 'fh',
  tech_job_function: 'fi',
  construction_dive_infrastructure_valid_subscribers: 'fj',
  construction_dive_labor_safety_valid_subscribers: 'fk',
  supply_chain_dive_logistics_valid_subscribers: 'fl',
  payers_on_healthcare: 'fm',
  providers_on_healthcare: 'fn',
};

function lyticsCallback(profile) {
  const usersAudienceArray = profile.data.user.segments;
  // for loop to iterate through the usersAudienceArray and create a new array of segmentIds
  const segmentIds = [];
  for (let i = 0; i < usersAudienceArray.length; i += 1) {
    if (lookup[usersAudienceArray[i]]) {
      segmentIds.push(lookup[usersAudienceArray[i]]);
    }
  }
  // if the segmentIds array is empty, skip sending the event
  if (segmentIds.length === 0) {
    return;
  }

  const lyticsProfileEventObject = {
    event: 'user.lyticsProfile',
    'user.lyticsProfile': {
      audiences: segmentIds.join(','),
    },
  };
  window.pushGTMEvent(lyticsProfileEventObject);
  console.log('Lytics event fired. Pushed', segmentIds.length, 'segments to GA4');
}
/* eslint-disable-next-line no-undef */
jstag.call('entityReady', lyticsCallback);
